import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'validDate',
  pure: true
})
export class ValidDatePipe implements PipeTransform {

  transform(value: Date | number | string): boolean {
    try {
      if (!value) { return false; } else if (!isNaN(+value)) { value = new Date(+value); } else if (typeof value == 'string') { value = new Date(!value.includes('Z') && !value.includes('+') ? value + 'Z' : value); }

      return (<Date>value).getTime() > (new Date('1900-01-01')).getTime();
    } catch (err) {
      console.error(err);
      return false;
    }
  }

}
